// Help lives on docs.plunk.io (DS 2026-10-24). Route prefix → docs page for "Help for this page";
// longest prefix wins. Docs URLs are stable (the docs site redirects if a page moves).
export const DOCS = 'https://docs.plunk.io';
const ROUTES = {
  '/': '/commerce/sales/dashboard/',
  '/Setup': '/commerce/get-started/connect-your-data/',
  '/Sales': '/commerce/sales/sales-overview/',
  '/Territory': '/commerce/sales/territory-and-reps/',
  '/Dealers': '/commerce/customers/dealers/',
  '/Stores': '/commerce/sales/stores-and-goals/',
  '/Products': '/commerce/products/products/',
  '/ProductPerformance': '/commerce/products/products/',
  '/Configurations': '/commerce/products/configurations/',
  '/Forecast': '/commerce/products/forecasts/',
  '/Inventory': '/commerce/products/inventory-planner/',
  '/Customers': '/commerce/customers/dealers/',
  '/Contacts': '/commerce/customers/contacts/',
  '/Audiences': '/commerce/customers/audiences/',
  '/Campaigns': '/commerce/marketing/campaigns-and-flights/',
  '/Autopilot': '/commerce/marketing/autopilot/',
  '/Email': '/commerce/marketing/email-journeys/',
  '/EmailAutomation': '/commerce/marketing/email-automations/',
  '/Content': '/commerce/marketing/content-hub/',
  '/SiteActivity': '/commerce/marketing/website-analytics/',
  '/MarketIntelligence': '/commerce/marketing/market-intelligence/',
  '/AiVisibility': '/commerce/apps/ai-visibility/',
  '/Keywords': '/commerce/apps/keyword-intelligence/',
  '/Apps': '/commerce/apps/',
  '/Reports': '/commerce/workspace/reports-and-schedules/',
  '/Data': '/commerce/workspace/manage-data/',
  '/Activity': '/commerce/workspace/activity-log/'
};
export function docsForPath(pathname) {
  let best = '/commerce/';
  let bestLen = 0;
  Object.keys(ROUTES).forEach(r => {
    const hit = r === '/' ? pathname === '/' : pathname === r || pathname.startsWith(r + '/');
    if (hit && r.length > bestLen) {
      best = ROUTES[r];
      bestLen = r.length;
    }
  });
  return DOCS + best;
}
export function supportUrl(pathname, type) {
  const q = new URLSearchParams({
    app: 'commerce',
    page: pathname || '/'
  });
  if (type) q.set('type', type);
  return DOCS + '/support/?' + q.toString();
}